module.exports = __webpack_public_path__ + "135ff2907b93653a1240ceaf28ae3a0e.svg";